import React from 'react';
import { Arrow } from 'components/Icons';
import { PrismicLink } from 'components/PrismicLink';
import { PrismicTitleFieldType, PrismicLinkFieldType, SliceContext } from '../types';
import './Feature.scss';

export type FeatureCTAProps = {
    ctaLabel: PrismicTitleFieldType;
    ctaLink: PrismicLinkFieldType;
    sliceContext: SliceContext;
};

const FeatureCTA = ({ ctaLabel, ctaLink, sliceContext }: FeatureCTAProps) => {
    if (!ctaLink || !ctaLabel || !ctaLabel.raw) {
        return null;
    }

    return (
        <PrismicLink link={ctaLink} className="Feature-cta-link" slice={sliceContext}>
            <div className="Grid Grid--alignCenter">
                <p>
                    {/* TODO: Make this a key text field in Prismic instead of rich text */}
                    {ctaLabel.raw[0].text}
                    <Arrow className="Feature-cta-arrow" />
                </p>
            </div>
        </PrismicLink>
    );
};

export default FeatureCTA;
